var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadGooglePlayPtBr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 53.334,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40h135V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 53.334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-125c-2.75 0-5 2.25-5 5v30c0 2.75 2.25 5 5 5H0c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-125c-2.75 0-5-2.25-5-5v-30c0-2.75 2.25-5 5-5H0c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5m0-.8C2.316-.8 4.2-2.684 4.2-5v-30c0-2.316-1.884-4.2-4.2-4.2h-125a4.205 4.205 0 0 0-4.2 4.2v30c0 2.316 1.884 4.2 4.2 4.2z",
    style: {
      fill: "#a6a6a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(130 40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.936 10h1.866v12.501h-1.866zm16.807 7.998-2.139-5.42h-.064l-2.22 5.42h-2.01l3.329-7.575-1.898-4.214h1.946l5.131 11.789zm-10.582-6.578c-.612 0-1.464.306-1.464 1.062 0 .965 1.061 1.334 1.978 1.334.82 0 1.206-.177 1.705-.418a2.262 2.262 0 0 0-2.219-1.978m.225 6.851c-1.351 0-2.751-.595-3.33-1.913l1.657-.692c.354.692 1.013.917 1.705.917.965 0 1.946-.579 1.962-1.608v-.129c-.338.193-1.062.482-1.946.482-1.785 0-3.603-.981-3.603-2.814 0-1.673 1.464-2.75 3.104-2.75 1.255 0 1.946.562 2.381 1.222h.064v-.965h1.801v4.793c0 2.219-1.656 3.457-3.795 3.457m-11.532-1.795H99.2v4.286h2.654c1.395 0 2.187-1.156 2.187-2.143 0-.969-.792-2.143-2.187-2.143m-.048 6.025h-4.471V10H99.2v4.736h2.606c2.068 0 4.101 1.498 4.101 3.883s-2.033 3.882-4.101 3.882M77.425 11.418c-1.289 0-2.368 1.079-2.368 2.561 0 1.498 1.079 2.594 2.368 2.594 1.273 0 2.271-1.096 2.271-2.594 0-1.482-.998-2.561-2.271-2.561m2.142 5.88h-.064c-.419.499-1.224.951-2.239.951-2.127 0-4.076-1.869-4.076-4.27 0-2.384 1.949-4.237 4.076-4.237 1.015 0 1.82.451 2.239.967h.064v-.612c0-1.628-.869-2.497-2.271-2.497-1.144 0-1.853.821-2.143 1.514l-1.627-.677c.467-1.128 1.708-2.513 3.77-2.513 2.191 0 4.044 1.289 4.044 4.43v7.637h-1.773ZM82.628 10h1.869v12.502h-1.869zm4.624 4.124c-.048 1.644 1.273 2.481 2.223 2.481.742 0 1.37-.37 1.579-.902zm5.8 1.418c-.355.951-1.434 2.707-3.641 2.707-2.191 0-4.011-1.724-4.011-4.254 0-2.384 1.804-4.253 4.22-4.253 1.95 0 3.077 1.192 3.545 1.885l-1.45.967c-.484-.709-1.144-1.176-2.095-1.176-.95 0-1.627.435-2.062 1.288l5.687 2.353zm-45.308 1.401v-1.804h4.317c-.129-1.015-.467-1.756-.982-2.271-.629-.629-1.612-1.321-3.335-1.321-2.659 0-4.737 2.142-4.737 4.801 0 2.658 2.078 4.8 4.737 4.8 1.434 0 2.481-.563 3.254-1.288l1.273 1.272c-1.08 1.031-2.513 1.821-4.527 1.821-3.641 0-6.702-2.965-6.702-6.605 0-3.642 3.061-6.606 6.702-6.606 1.965 0 3.447.645 4.607 1.853 1.192 1.192 1.563 2.867 1.563 4.221 0 .419-.032.805-.097 1.127zm11.078-5.525c-1.288 0-2.4 1.063-2.4 2.577 0 1.531 1.112 2.578 2.4 2.578 1.289 0 2.401-1.047 2.401-2.578 0-1.514-1.112-2.577-2.401-2.577m0 6.831c-2.352 0-4.269-1.789-4.269-4.254 0-2.448 1.917-4.253 4.269-4.253 2.352 0 4.27 1.805 4.27 4.253 0 2.465-1.918 4.254-4.27 4.254m9.314-6.831c-1.289 0-2.401 1.063-2.401 2.577 0 1.531 1.112 2.578 2.401 2.578 1.289 0 2.4-1.047 2.4-2.578 0-1.514-1.111-2.577-2.4-2.577m0 6.831c-2.352 0-4.269-1.789-4.269-4.254 0-2.448 1.917-4.253 4.269-4.253 2.352 0 4.269 1.805 4.269 4.253 0 2.465-1.917 4.254-4.269 4.254",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-10.647-11.3.002-.007a2.874 2.874 0 0 1 4.236-1.734l.034.02L5.609-6.106z",
    style: {
      fill: "#ea4335",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(20.717 20.576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.01.007-5.174 2.999-5.829-5.187 5.85-5.848L-.017-5.06A2.88 2.88 0 0 1 0 0",
    style: {
      fill: "#fbbc04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(31.488 22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a2.823 2.823 0 0 1-.098-.74v-19.968c0-.256.034-.504.099-.739l11.012 11.011z",
    style: {
      fill: "#4285f4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(10.07 30.723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.51 5.509-11.97 6.94a2.878 2.878 0 0 1-4.265-1.722l-.001-.003z",
    style: {
      fill: "#34a853",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(20.796 20)"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1.33333 0 0 1.33333 54.773 17.511)",
    style: {
      fontVariant: "normal",
      fontWeight: 500,
      fontStretch: "normal",
      fontSize: "8.7px",
      fontFamily: "'Google Sans Medium'",
      InkscapeFontSpecification: "GoogleSans-Medium",
      writingMode: "lr-tb",
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.4458299 9.0236397 14.20014 19.515841 26.910839 33.418442 35.923168 41.76783 46.900829 51.528358 53.564159 60.05349",
    y: 0
  }, "DISPON\xCDVEL NO"))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadGooglePlayPtBr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download_google_play_PT_BR.7bebfd460cbf699e8e7320c942a903a0.svg";